var url = "8510fa40dd0b0c8ce3a38a2dab99ec2c.png";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;